import * as yup from "yup";

import type { UpdatePhysician } from "@elation/api-client/src/stitch-web/models";

import type { YupSchemaValue } from "@src/shared/utils/yup";

import { PhysicianEntity } from "./physician.entity";

export const PhysicianSpecialtySelectItems =
  PhysicianEntity.specialtyOptions().map((value) => ({
    label: value,
    value,
  }));

export const PhysicianProfileFormValidationSchema = yup.object({
  firstName: yup.string().trim().required("First name is required"),
  middleName: yup.string().default(""),
  lastName: yup.string().trim().required("Last name is required"),
  specialty: yup.string().default(""),
});

export type PhysicianProfileFormValues = YupSchemaValue<
  typeof PhysicianProfileFormValidationSchema
>;

export const PhysicianNpiSearchByNameFormValidationSchema = yup.object({
  firstName: yup.string().trim().required("First name is required"),
  lastName: yup.string().trim().required("Last name is required"),
  state: yup.string().default("ANY"),
});

export type PhysicianNpiSearchByNameFormValues = YupSchemaValue<
  typeof PhysicianNpiSearchByNameFormValidationSchema
>;

export const PhysicianNpiLookupFormValidationSchema = yup.object({
  npi: yup
    .string()
    .trim()
    .matches(/^\d{10}$/, "NPI must be 10 digits")
    .required("NPI is required"),
});

export type PhysicianNpiLookupFormValues = YupSchemaValue<
  typeof PhysicianNpiLookupFormValidationSchema
>;

export const PhysicianProfileUpdatePayloadSchema = yup
  .object({
    firstName: yup.string().trim().required(),
    middleName: yup
      .string()
      .trim()
      .nullable(true)
      .transform((value) => value || null),
    lastName: yup.string().trim().required(),
    specialty: yup
      .string()
      .trim()
      .transform((value) => value || undefined),
  })
  .default(undefined) as yup.Schema<UpdatePhysician>;
